import axios from 'axios';
import { checkFoundation } from './common';
import { ICompletePayload, ICompleteResponse } from '../types/complete';
import { Location, OperationType, OrganizationType } from '../types/enums';
import { Model } from 'survey-core';
import { SELF_SERVE_VALUE } from '../components/questionTypes/MuiAdditionalProducts';
import { SubscriptionTiers } from '@pec/aion-ui-core/enums/Subscription';

export const handleFormCompletion = async (model: Model) => {
  const {
    organizationType = null,
    subcontractorEmployeeCount,
    totalEmployeeCount,
    subscriptionSelect,
    additionalProducts,
    dataSharingConsent,
    applicationType = null,
    assessmentType = null,
    paymentMethod
  } = model.data;

  const products = [subscriptionSelect];
  const taxRate = model.getVariable('taxRate');
  const discount = model.getVariable('discount');
  const {
    organizationId,
    subscriptionId,
    email,
    operationType,
    location,
    currentSubscription,
    assessmentType: infoAssessmentType
  } = model.getVariable('info');
  const subscriptionTier =
    subscriptionSelect && model.runExpression(`expandChoicesByUrl('${subscriptionSelect}', subscriptionTier)`);
  const GBElitePackage = subscriptionTier === SubscriptionTiers.Elite && location === Location.GB;
  const isFoundation = checkFoundation(currentSubscription);

  if (additionalProducts && additionalProducts !== SELF_SERVE_VALUE) {
    products.push(additionalProducts);
  }

  if (model.runExpression('getJoiningFee()') > 0) {
    products.push(model.runExpression("getJoiningFee('id')"));
  }

  const page = operationType === OperationType.Upgrade ? 'upgrade' : 'renew';
  const body: ICompletePayload = {
    companyType: isFoundation ? organizationType : null,
    applicationType:
      isFoundation && organizationType === OrganizationType.Supplier ? OrganizationType.Supplier : applicationType,
    assessmentType:
      isFoundation && organizationType === OrganizationType.Supplier && infoAssessmentType
        ? 'Direct Application'
        : assessmentType,
    operationType: isFoundation ? OperationType.SignUp : operationType,
    organizationId,
    subscriptionId,
    subscriptionTier,
    email,
    products,
    subcontractorEmployeeCount,
    totalEmployeeCount,
    taxRateId: taxRate?.isActive ? taxRate.paymentProviderRateId : null,
    successUrl: `${window.location.origin}/organizations/${organizationId}/${page}/success?email=${encodeURIComponent(
      email
    )}&operationType=${operationType}`,
    cancelUrl: `${window.location.origin}/organizations/${organizationId}/${page}`,
    location: location,
    discountCodeId: discount?.id ?? null,
    discountCode: discount?.code ?? null,
    dataSharingConsent: GBElitePackage ? Boolean(dataSharingConsent) : null,
    paymentMethod
  };

  return axios.post<ICompleteResponse>(
    `/api/v1/organizations/${organizationId}/subscriptions/${subscriptionId}/checkout`,
    body
  );
};

export const checkCompletionOnServer = (transactionId: string | null) => {
  if (!transactionId) throw new Error('transactionId is empty');
  const waitForCompletion: (initial?: boolean) => Promise<boolean | undefined> = async initial => {
    if (!initial) {
      await new Promise(resolve => setTimeout(resolve, 3000));
    }
    const res = await axios.get<boolean>(`/api/v2/payments/is-completed/${transactionId}`);

    if (res.status !== 200) {
      return Promise.resolve(false);
    }
    if (!res.data) {
      return waitForCompletion();
    }
    return Promise.resolve(true);
  };

  return waitForCompletion(true);
};
